import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { SalService } from 'src/app/Services/sal/sal.service';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';

@Component({
  selector: 'app-sale-subscription',
  templateUrl: './sale-subscription.component.html',
  styleUrls: ['./sale-subscription.component.css']
})
export class SaleSubscriptionComponent implements OnInit {

  constructor( private Productservice: SalService,private subcriptionService: SubscriptionService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SearchModel = {
    SchoolID: 0,
    BranchID: 0,
    PackageID: 0
  }
  SubscriptionList=[];
  GetAllSubscription() {
    this.SubscriptionList = [];
    this.spinnerService.show();
    this.Productservice.GetGroupSubscription(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.SubscriptionList = data.CustomerSubscriptionList;
      this.spinnerService.hide();

    });
  };


  ngOnInit() {
    this.SearchModel.SchoolID=this.globalHelper.GetLoginToken().SchoolID;
    this.GetAllSubscription();
  }

}
